<template>
  <div id="campaign-page">
    <div class="top-bar">
      <div class="button-create-campaign" @click="openModalCreateCampaign()">+</div>
      <modal-create-campaign
        v-if="showModal"
        @hide-modal="openModalCreateCampaign()"
        :modalType="'tester'"
        :users="testerOrOperatorList"
        :checkRoute="false"
        :isCreate="isCreate"
        :contactsSelected="contactsSelected"
        :inputForm="inputForm"
      />
      <div class="search-form">
        <v-text-field
          class="search-text-field"
          placeholder="Tìm kiếm theo sđt"
          clearable
        ></v-text-field>
        <div class="group-btn-search">
          Tìm kiếm
          <v-menu
            :internal-activator="true"
            v-model="filter.closeMenu"
            content-class="menu__customer no-contain overflow-visible"
            :close-on-content-click="false"
            style="z-index: 10"
          >
            <template v-slot:activator="menuON">
              <v-tooltip right style="z-index: 10;">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    medium
                    color="white"
                    v-on="on"
                    class="search-contact--dropdown"
                  >
                    <v-icon size="20"
                            v-on="menuON.on"
                    >mdi-chevron-down
                    </v-icon>
                  </v-btn>
                </template>
                <span>Tìm kiếm nâng cao</span>
              </v-tooltip>
            </template>
            <card-filter-form
              :filter="filter"
              :filterForm.sync="filterForm"
              :tab.sync="tab"
            />
          </v-menu>
        </div>
      </div>
    </div>
    <div class="campaign-table">
      <v-simple-table v-if="!isLoading && campaigns">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              Phễu chăm sóc
            </th>
            <th class="text-left" style="width: 130px;">
              Loại
            </th>
            <th class="text-left" style="width: 150px;">
              Nhân sự
            </th>
            <th class="text-left" style="width: 260px;">
              Tiến độ
            </th>
            <th class="text-left">
              Tổng
            </th>
            <th class="text-left" style="width: 160px;">
              Hoàn thành
            </th>
            <th class="text-left" style="width: 260px;">
              Thua
            </th>
            <th class="text-left" style="width: 160px;">
              Thao tác
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="campaign in campaigns"
            :key="campaign.id"
          >
            <td>
              <span class="campaign-detail" @click="openModalUpdateCampaign(campaign)">{{ campaign.name }}</span>
            </td>
            <td>{{ campaign.type }}</td>
            <td>+{{ campaign.hr }}</td>
            <td>
              <v-progress-linear
                v-model="campaign.percentage"
                color="#EB5757"
                height="15"
              >
                <template v-slot:default="{ value }">
                  <strong>{{ Math.ceil(value) }}%</strong>
                </template>
              </v-progress-linear>
            </td>
            <td>{{ campaign.total }}</td>
            <td>{{ campaign.completed }}</td>
            <td>{{ campaign.lost }}</td>
            <td>
              <v-switch
                v-model="campaign.is_active"
                color="info"
                hide-details
              ></v-switch>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-data-table
        v-else
        item-key="name"
        class="elevation-1"
        loading
        loading-text="Loading... Please wait"
      ></v-data-table>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapActions,
} from 'vuex';
import CardFilterForm from './components/CardFilterForm.vue';
import ModalCreateCampaign from './components/ModalCreateCampaign.vue';

export default {
  name: 'Home',
  components: {
    CardFilterForm,
    ModalCreateCampaign,
  },
  data() {
    return {
      isLoading: false,
      searchInput: '',
      filter: {
        closeMenu: false,
      },
      isCreate: true,
      showModal: false,
      tab: 1,
      items: ['foo', 'bar', 'fizz', 'buzz'],
      value: ['foo', 'bar', 'fizz', 'buzz'],
      users: [],
      filterForm: {
        status: '',
        searchInfo: '',
        dateTime: [],
        type: null,
        subjectId: null,
        operatorOrTesterId: [],
        interviewUser: [],
        createdBy: [],
        listInterviews: [],
        createdAt: [],
        selectedShift: [],
        caseTypeIds: [],
      },
      inputForm: {
        name: '',
        testerId: [],
      },
      campaigns: [
        {
          id: 1,
          name: 'Pheu cham so gia su',
          type: 'Gia su',
          hr: 4,
          total: 500,
          completed: 380,
          percentage: 90,
          lost: 122,
          is_active: true,
        },
        {
          id: 2,
          name: 'Pheu cham soc tu hoc',
          type: 'Tu hoc',
          hr: 2,
          total: 230,
          completed: 246,
          percentage: 20,
          lost: 8,
          is_active: true,
        },
        {
          id: 3,
          name: 'Customize 1',
          type: 'Tuy chinh',
          hr: 2,
          total: 100,
          completed: 40,
          percentage: 40,
          lost: 32,
          is_active: false,
        },
      ],
      testerOrOperatorList: [
        {
          fullName: 'Jung Kook',
          id: 468,
          username: 'Jungkook',
          firstName: 'Kook',
          lastName: 'Jung',
          birthday: null,
          gender: '',
          phone: '',
          ext: '',
          extPassword: '',
          email: '',
          password: '$2b$08$HP0MzXPiWlaoVfSwkGF2teLXhuN9jElWk4o1yyOSzMmyiECtoRSRe',
          departmentId: 56,
          avatarId: null,
          position: 'telesales',
          allGroup: false,
          offAssignContact: false,
          status: 'active',
          roleId: 0,
          lastLoginAt: null,
          createdBy: null,
          updatedBy: 1,
          callCenterId: null,
          store: 'T',
          number_of_contact: null,
          number_of_contact_m: null,
          number_of_contact_a: null,
          number_of_contact_e: null,
          departmentType: 'retail',
          siteId: 2,
          timeTokenInactive: null,
          isManager: 0,
          isPartner: 0,
          isMarketing: 0,
          typeId: 2,
          schoolLevelId: 1,
          identifier: null,
          createdAt: '2021-10-15 16:49:26',
          updatedAt: '2021-10-15 17:47:39',
          deletedAt: null,
          userRole: [{
            id: 35,
            userId: 468,
            roleId: 47,
            createdBy: 1,
            updatedBy: 1,
            createdAt: '2021-10-30 16:43:00',
            updatedAt: '2021-10-30 16:43:00',
            deletedAt: null,
          }],
        },
        {
          fullName: 'Jiso O',
          id: 122,
          username: 'bachdang',
          firstName: 'O',
          lastName: 'Jiso',
          birthday: '2020-10-19 07:00:00',
          gender: '',
          phone: '',
          ext: '',
          extPassword: '',
          email: 'bachdang@gmail.com',
          password: '$2b$08$8sxHX5uSIyXdSJsyRpiHS.9jiy/PRH6OhPBxcK5uwsRyuzRN2RcEu',
          departmentId: 52,
          avatarId: null,
          position: 'telesales',
          allGroup: false,
          offAssignContact: false,
          status: 'active',
          roleId: 2,
          lastLoginAt: '2022-01-23 17:48:32',
          createdBy: 1,
          updatedBy: 1,
          callCenterId: null,
          store: 'C',
          number_of_contact: null,
          number_of_contact_m: null,
          number_of_contact_a: null,
          number_of_contact_e: null,
          departmentType: 'retail',
          siteId: 2,
          timeTokenInactive: '2021-07-06 12:07:32',
          isManager: 0,
          isPartner: 0,
          isMarketing: 0,
          typeId: 2,
          schoolLevelId: 2,
          identifier: null,
          createdAt: '2020-10-19 14:51:51',
          updatedAt: '2022-01-23 17:48:32',
          deletedAt: null,
          userRole: [{
            id: 36,
            userId: 122,
            roleId: 47,
            createdBy: 1,
            updatedBy: 1,
            createdAt: '2021-10-30 16:43:00',
            updatedAt: '2021-10-30 16:43:00',
            deletedAt: null,
          }],
        },
      ],
      contactsSelected: [{
        id: 946,
        contactId: 27337,
        code: 'VH027337',
        customerId: 40076,
        mobile: '0912903890',
        email: '',
        hasOrder: 1,
        isManual: 0,
        userName: 'beo đang chekc bug',
        parentName: 'beo',
        createdAt: '2022-06-17 16:42:01',
        updatedAt: '2022-06-17 16:42:01',
        birthday: 2008,
        customers: [{
          id: 40076,
          contactId: 27337,
          fullName: 'beo đang chekc bug',
          birthday: 2008,
          position: 'child',
        }],
        color: '#FF3D00;',
        contactTutorPractice: [{
          id: 1865,
          contactTutorId: 946,
          contactId: 27337,
          subjectId: 1,
          monCode: 'toan',
          gradeId: null,
          vhResultId: null,
          status: 0,
          statusLink: null,
          testLink: null,
          interviewStatus: null,
          interviewUser: null,
          interviewComment: null,
          appointmentTime: null,
          appointmentAt: null,
          appointmentTestLevel: 1,
          appointmentLink: null,
          testResult: null,
          testResultCreatedAt: null,
          commentStatus: null,
          commentBy: null,
          commentContent: null,
          commentLearningPath: null,
          operatorId: null,
          operatorName: '',
          interviewCalenderId: null,
          learningPathLink: null,
          videoLink: null,
          createdAt: '2022-06-17 16:42:01',
          updatedAt: '2022-06-17 16:42:01',
          createdBy: 1,
          updatedBy: 100004,
          type: 1,
          isHotOrder: 1,
          studentLevel: null,
          statusLabel: 'Chờ xếp chỗ',
          interviewName: '',
          inviterName: 'Baby Shark',
          learningPathLinkCopy: null,
          videoLinkCopy: null,
          comfirmed: false,
          canceled: false,
          menu: false,
        }, {
          id: 1865,
          contactTutorId: 946,
          contactId: 27337,
          subjectId: 1,
          monCode: 'toan',
          gradeId: null,
          vhResultId: null,
          status: 0,
          statusLink: null,
          testLink: null,
          interviewStatus: null,
          interviewUser: null,
          interviewComment: null,
          appointmentTime: null,
          appointmentAt: null,
          appointmentTestLevel: 1,
          appointmentLink: null,
          testResult: null,
          testResultCreatedAt: null,
          commentStatus: null,
          commentBy: null,
          commentContent: null,
          commentLearningPath: null,
          operatorId: null,
          operatorName: '',
          interviewCalenderId: null,
          learningPathLink: null,
          videoLink: null,
          createdAt: '2022-06-17 16:42:01',
          updatedAt: '2022-06-17 16:42:01',
          createdBy: 1,
          updatedBy: 100004,
          type: 1,
          isHotOrder: 1,
          studentLevel: null,
          statusLabel: 'Chờ xếp chỗ',
          interviewName: '',
          inviterName: 'Baby Shark',
          learningPathLinkCopy: null,
          videoLinkCopy: null,
          comfirmed: false,
          canceled: false,
          menu: false,
        }],
        sortAppointmentTime: 0,
        sortCreatedAt: '2022-06-17 16:42:01',
        isCheck: true,
      }],
    };
  },
  mounted() {
  },
  computed: {
    ...mapState('login', ['user']),
  },
  methods: {
    ...mapActions('login', ['getUserProfile']),
    inputNull() {
      console.log(this.searchInput);
    },
    search() {
      console.log('search', this.searchInput);
    },
    openModalCreateCampaign() {
      this.showModal = !this.showModal;
      this.isCreate = true;
    },
    openModalUpdateCampaign(campaign) {
      this.showModal = true;
      this.inputForm = {
        name: campaign.name,
        testerId: [],
      };
      this.isCreate = false;
    },
  },
};
</script>

<style scoped lang="scss">
.top-bar {
  min-height: 60px;
  min-width: 900px;
  border-radius: 0px;
  background: #FFFFFF;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px 10px 15px;
}

.button-create-campaign {
  width: 60px;
  height: 40px;
  background: #E91E63;
  border-radius: 5px;
  font-size: 28px;
  color: #FFFFFF;
  font-weight: 450;
  text-align: center;
  cursor: pointer;
}

.search-form {
  min-width: 250px;
  height: 22px;
  display: flex;
  justify-content: flex-start;
}

.search-text-field {
  margin-top: -10px !important;
}

.group-btn-search {
  height: 36px;
  min-width: 80px;
  background: #E91E63;
  border-radius: 3px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  padding: 9px;
  margin-left: 20px;
}

.campaign-detail {
  color: #2F80ED;
  cursor: pointer;
}

.campaign-table {
  margin-top: 20px;

  thead {
    background-color: #0395EE;
  }

  border-collapse: collapse;
  border-radius: 4px 4px 0px 0px;
  border-style: hidden; /* hide standard table (collapsed) border */
  box-shadow: 0 0 0 1px #F5F5F5;

  tr {
    th {
      font-weight: 500 !important;
      font-size: 13px !important;
      line-height: 20px !important;
      color: #FFFFFF !important;
    }
  }

  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
  }

  .v-progress-linear {
    border-radius: 10px;
    background-clip: padding-box;
    max-width: 160px;
  }
}
</style>
